import { Box, SxProps } from '@mui/material'
import { useDrawerPortalContext } from './DrawerPortalProvider'

type DrawerPortalProps = {
  anchor?: 'left' | 'right'
  additionalId?: string
  sx?: SxProps
}

export default function DrawerPortal({
  anchor = 'left',
  additionalId,
  sx,
}: DrawerPortalProps) {
  const { setPortalNode, setSecondPortalNode } = useDrawerPortalContext()
  return (
    <Box
      ref={anchor === 'left' ? setPortalNode : setSecondPortalNode}
      data-portal-id={`drawers-${anchor}${
        additionalId ? `-${additionalId}` : ''
      }`}
      sx={{ flexShrink: 0, position: 'relative', ...sx }}
    />
  )
}
